module.exports = __webpack_public_path__ + "common/sidebar/icon-calendar-e88fa2316f61c5c761fa7f071f9a984f.svg";